export const USER_ROLES = {
    SUPERADMIN: 'superadmin',
    ADMIN:      'admin',
    MANAGER:    'manager',
    STAFF:      'staff',
};

export const ADMIN_ROLES    = [USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN];
export const OPERATOR_ROLES = [USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER];
export const ALL_ROLES      = Object.values(USER_ROLES);

export const SECTIONS = {
    DASHBOARD:        'dashboard',
    CUSTOMERS:        'customers',
    ORDERS:           'orders',
    CAMPAIGNS:        'campaigns',
    LOYALTY:          'loyalty',
    INVENTORY:        'inventory',
    REPORTS:          'reports',
    CHANNELS:         'channels',
    WEBSITE:          'website',
    SETTINGS:         'settings',
    BILLING:          'billing',
    STAFF_MANAGEMENT: 'staff_management',
    BOOKINGS:         'bookings',
    CALENDAR:         'calendar',
    RETURNS:          'returns',
    GIFT_CARDS:       'gift_cards',
    VOICE:            'voice',
};

export const DEFAULT_SECTION_ROLES = {
    [SECTIONS.DASHBOARD]:        ALL_ROLES,
    [SECTIONS.CUSTOMERS]:        ALL_ROLES,
    [SECTIONS.ORDERS]:           ALL_ROLES,
    [SECTIONS.CAMPAIGNS]:        OPERATOR_ROLES,
    [SECTIONS.LOYALTY]:          OPERATOR_ROLES,
    [SECTIONS.BOOKINGS]:         OPERATOR_ROLES,
    [SECTIONS.CALENDAR]:         OPERATOR_ROLES,
    [SECTIONS.INVENTORY]:        ADMIN_ROLES,
    [SECTIONS.REPORTS]:          ADMIN_ROLES,
    [SECTIONS.CHANNELS]:         ADMIN_ROLES,
    [SECTIONS.WEBSITE]:          ADMIN_ROLES,
    [SECTIONS.SETTINGS]:         ADMIN_ROLES,
    [SECTIONS.BILLING]:          ADMIN_ROLES,
    [SECTIONS.STAFF_MANAGEMENT]: ADMIN_ROLES,
    [SECTIONS.RETURNS]:          OPERATOR_ROLES,
    [SECTIONS.GIFT_CARDS]:       OPERATOR_ROLES,
    // Call transcripts and recordings hold customers' details; mirrors afto_api.
    [SECTIONS.VOICE]:            ADMIN_ROLES,
};

// Staff roles allowed each wallet action; mirrors WALLET_ACTION_ROLES in afto_api.
// Corrections stay admins-only until a second approver exists.
export const WALLET_ACTION_ROLES = {
    FREEZE:  OPERATOR_ROLES,
    CORRECT: ADMIN_ROLES,
    // Offering a return as store credit is its own permission (S-6).
    STORE_CREDIT: ADMIN_ROLES,
};

/**
 * Returns true if `role` can access `section`, consulting the live `rolePermissions`
 * map (from session) before falling back to DEFAULT_SECTION_ROLES constants.
 *
 * @param {string} role - e.g. 'manager', 'staff', 'admin'
 * @param {string} section - a SECTIONS value
 * @param {object|null} rolePermissions - session.user.rolePermissions map
 */
export function canAccessSection(role, section, rolePermissions) {
    if (ADMIN_ROLES.includes(role)) return true;
    if (rolePermissions?.[role]?.sections) {
        return rolePermissions[role].sections.includes(section);
    }
    const defaultRoles = DEFAULT_SECTION_ROLES[section];
    return Array.isArray(defaultRoles) && defaultRoles.includes(role);
}
